import textParser from "./textParser";

export default (faqs: { question: string; answer: string }[]) => {
    const mainEntity = faqs.map((faq) => {
        return {
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
                "@type": "Answer",
                text: textParser({
                    text: faq.answer,
                    units: "C",
                    noNbsp: true
                })
            }
        };
    });
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: mainEntity
    };
    return JSON.stringify(structuredData);
};
